export default __webpack_public_path__ + "static/media/logo.22459221.png";